export default __webpack_public_path__ + "static/media/logo_cobotics.3c4fcfc3.png";